<div class="container-fluid px-0" style="position: relative">
  <!-- Monitoring Component -->
  <app-monitoring
    [connectionIssuesCount]="stationsWithConnectionIssuesCount"
    [missingDataCount]="missingDataCount"
    [nonConformitiesCount]="nonConformitiesCount"
    [isLoadingConnectionIssues]="isLoadingConnectionIssues"
    [isLoadingMissingData]="isLoadingMissingData"
    [isLoadingNonConformities]="isLoadingNonConformities"
  />

  <!-- SAD Summary Component -->
  <app-sad-summary
    [rustAlertCount]="rustAlertCount"
    [phomaAlertCount]="phomaAlertCount"
    [isLoadingRustAlert]="isLoadingRustAlert"
    [isLoadingPhomaAlert]="isLoadingPhomaAlert"
  />

  <!-- Meteorological Data Component -->
  <app-meteorological-data
    [stations]="averageStations"
    [nearestStationId]="nearestStationDetail?.id ?? null"
  />
</div>
